import { useState } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Divider, FormControlLabel, Grid2 as Grid, Switch } from '@mui/material';
import { FINANCIAL_FIELDS_HIDDEN_BY_DEFAULT, TOGGLEABLE_COLUMNS } from 'common/constants/analyst-dashboards';
import { EnhancedTableHeadColumn } from '../ValuationsTable.types';

const WorkboardTableColumnToggleList = ({ 
  columns, 
  columnVisibility, 
  onColumnsToggle 
}: { 
  columns: EnhancedTableHeadColumn[], 
  columnVisibility: Record<string, boolean>,
  onColumnsToggle: (columnId: string) => void 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const filteredColumns = columns.filter((column: EnhancedTableHeadColumn) => TOGGLEABLE_COLUMNS.includes(column.id));
  const financialColumns = filteredColumns.filter(column => FINANCIAL_FIELDS_HIDDEN_BY_DEFAULT.includes(column.id));
  const otherColumns = filteredColumns.filter(column => !FINANCIAL_FIELDS_HIDDEN_BY_DEFAULT.includes(column.id));
  
  // Check if all financial columns are visible
  const areAllFinancialColumnsVisible = financialColumns.every(column => columnVisibility[column.id] !== false);
  
  const handleFinancialsToggle = () => {
    const newState = !areAllFinancialColumnsVisible;
    financialColumns.forEach(column => {
      if (columnVisibility[column.id] !== newState) {
        onColumnsToggle(column.id);
      }
    });
  };
  
  return (
    <>
      {isOpen ? (
        <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
          <DialogTitle>Toggle Columns</DialogTitle>
          <DialogContent>
            <Box sx={{ minWidth: 500 }}>
              <Grid container spacing={2}>
                {otherColumns.map((column: EnhancedTableHeadColumn) => (
                  <Grid size={6} key={column.id}>
                    <FormControlLabel 
                      control={
                        <Switch 
                          checked={columnVisibility[column.id] !== false} 
                          onChange={() => onColumnsToggle(column.id)} 
                        />
                      } 
                      label={column.label} 
                    />
                  </Grid>
                ))}
              </Grid>
              {financialColumns.length > 0 && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <FormControlLabel 
                    control={
                      <Switch 
                        checked={areAllFinancialColumnsVisible} 
                        onChange={handleFinancialsToggle} 
                      />
                    } 
                    label="Financials Values" 
                  />
                </>
              )}
            </Box>
          </DialogContent>
        </Dialog>
      ) : (
        <Button onClick={() => setIsOpen(!isOpen)}>
          Toggle Columns
        </Button>
      )}
    </>
  );
};

export default WorkboardTableColumnToggleList;

